import { notification } from "antd";
import { picsArtInstance } from "./picsArtConfig";
class Functions {
  url = "";
  sliderValue = 100;
  undo = [];
  redo = [];

  constructor(imageUrl) {
    this.url = imageUrl;
  }

  async handleImageSize(size) {
    this.sliderValue = size;
    await new Promise((resolve) => setTimeout(resolve, 300));
  }
  // Set a new URL
  async updateCurrentURL(newURL) {
    this.undo.push(this.url);
    this.url = newURL;
  }
  // Get the current URL
  getUrl() {
    return this.url;
  }

  handleUndo() {
    if (this.undo.length === 0) return;
    const undoLastIdx = this.undo.length - 1;
    const previousUpdate = this.undo[undoLastIdx];
    this.redo.push(this.url);
    this.undo.pop();
    this.url = previousUpdate;
  }

  handleRedo() {
    if (this.redo.length === 0) return;
    const redoLastIdx = this.redo.length - 1;
    const previousUpdate = this.redo[redoLastIdx];
    this.undo.push(this.url);
    this.redo.pop();
    this.url = previousUpdate;
  }

  async getImageSize(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = function () {
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      };
      img.onerror = reject;
      img.src = url;
    });
  }

  async calculateCropSize(targetRatio) {
    const { width: originalWidth, height: originalHeight } =
      await this.getImageSize(this.url);

    let cropWidth = originalWidth;
    let cropHeight = Math.round(cropWidth / targetRatio);
    if (cropHeight > originalHeight) {
      cropHeight = originalHeight;
      cropWidth = Math.round(cropHeight * targetRatio);
    }
    return {
      width: cropWidth,
      height: cropHeight,
    };
  }

  async calculateResizeSize(scale) {
    const { width: originalWidth, height: originalHeight } =
      await this.getImageSize(this.url);
    const newWidth = Math.round(originalWidth * scale);
    const newHeight = Math.round(originalHeight * scale);
    return {
      width: newWidth,
      height: newHeight,
    };
  }

  async changeBackground(image, bg_image = undefined) {
    try {
      const formData = new FormData();
      formData.append("output_type", "cutout");
      formData.append("bg_blur", "0");
      formData.append("scale", "fit");
      formData.append("auto_center", "true");
      formData.append("stroke_size", "0");
      formData.append("stroke_color", "FFFFFF");
      formData.append("stroke_opacity", "100");
      formData.append("shadow", "disabled");
      formData.append("shadow_opacity", "20");
      formData.append("shadow_blur", "50");
      formData.append("format", "PNG");
      // formData.append("image_url", this.url);
      const blob = await fetch(image).then((res) => res.blob());
      formData.append("image", blob, "image.png");

      if (bg_image) {
        if (typeof bg_image === "string") {
          formData.append("bg_image_url", bg_image);
        } else {
          formData.append("bg_image", bg_image);
        }
      }

      const response = await picsArtInstance.post(`/removebg`, formData);
      const { status, data } = response.data;
      if (status === "success") {
        this.updateCurrentURL(data.url);
        return data.url;
      } else {
        notification["error"]({
          message: "Background Change Failed",
          description: data?.message?.includes("402")
            ? "Picsart Credits Exhausted"
            : data?.message || "Unknown error occurred.",
          placement: "topRight",
        });
        return this.url;
      }
    } catch (error) {
      if (error.response && error.response.status === 402) {
        notification.error({
          message: "Picsart Credits Exhausted",
          description: "You have run out of Picsart API credits.",
          placement: "topRight",
        });
      } else {
        notification.error({
          message: "Background Change Failed",
          description: error.message || "An unexpected error occurred.",
          placement: "topRight",
        });
      }
      console.error("Error removing background:", error);
      return this.url;
    }
  }

  async updateRatio(ratio, image) {
    try {
      const { width, height } = await this.calculateCropSize(ratio);

      const formData = new FormData();
      formData.append("format", "PNG");
      // formData.append("rotate", "0");
      // formData.append("perspective_horizontal", "0");
      // formData.append("perspective_vertical", "0");
      formData.append("quality", "90");
      formData.append("mode", "crop");
      formData.append("width", width);
      formData.append("height", height);
      // formData.append("image_url", this.url);
      const blob = await fetch(image).then((res) => res.blob());
      formData.append("image", blob, "image.png");

      const response = await picsArtInstance.post(`/edit`, formData);
      const { status, data } = response.data;

      if (status === "success") {
        this.updateCurrentURL(data.url);
      } else {
        notification.error({
          message: "Image Ratio Update Failed",
          description: data?.message || "Unexpected server response.",
          placement: "topRight",
        });
      }
    } catch (error) {
      console.error("Error occurred while updating image ratio:", error);
      if (error.response && error.response.status === 402) {
        notification.error({
          message: "Picsart Credits Exhausted",
          description:
            "You have run out of Picsart API credits. Please upgrade your plan.",
          placement: "topRight",
        });
      } else {
        notification.error({
          message: "Background Change Failed",
          description: error.message || "An unexpected error occurred.",
          placement: "topRight",
        });
      }
    }
  }



  async getDimensionsByAspectRatio(originalWidth, originalHeight, targetRatio) {
  console.log({ originalWidth, originalHeight, targetRatio });
  const MAX_WIDTH = 299
  const MAX_HEIGHT = 519;

  const originalRatio = originalWidth / originalHeight;

  let newWidth, newHeight;

  if (originalRatio > targetRatio) {
    // Wider than target
    newHeight = originalHeight;
    newWidth = newHeight * targetRatio;
  } else {
    // Taller than target
    newWidth = originalWidth;
    newHeight = newWidth / targetRatio;
  }

  // Scale to fit inside max dimensions
  const widthRatio = MAX_WIDTH / newWidth;
  const heightRatio = MAX_HEIGHT / newHeight;
  const scale = Math.min(widthRatio, heightRatio, 1);

  return {
    width: Math.round(newWidth * scale),
    height: Math.round(newHeight * scale),
  };
}
  /**
 * Adjusts image to a given aspect ratio and returns a data URL of the result.
 * @param {string} imageUrl - URL of the image to be edited
 * @param {number} targetRatio - Desired aspect ratio (e.g. 16/9, 4/5)
 * @returns {Promise<string>} - Data URL of the adjusted image
 */
async updateImageAspectRatio(imageUrl, targetRatio){
  const img = new Image();
  img.crossOrigin = "Anonymous"; // to avoid CORS issues
  img.src = imageUrl;

  await new Promise((resolve, reject) => {
    img.onload = resolve;
    img.onerror = reject;
  });

  const originalWidth = img.width;
  const originalHeight = img.height;
  const originalRatio = originalWidth / originalHeight;

  let newWidth, newHeight, sx, sy, sWidth, sHeight;

  if (originalRatio > targetRatio) {
    // Image is wider than target
    newHeight = originalHeight;
    newWidth = newHeight * targetRatio;
    sx = (originalWidth - newWidth) / 2;
    sy = 0;
    sWidth = newWidth;
    sHeight = originalHeight;
  } else {
    // Image is taller than target
    newWidth = originalWidth;
    newHeight = newWidth / targetRatio;
    sx = 0;
    sy = (originalHeight - newHeight) / 2;
    sWidth = originalWidth;
    sHeight = newHeight;
  }

  const canvas = document.createElement("canvas");
  canvas.width = newWidth;
  canvas.height = newHeight;
  const ctx = canvas.getContext("2d");

  ctx.drawImage(img, sx, sy, sWidth, sHeight, 0, 0, newWidth, newHeight);
  return canvas.toDataURL("image/jpeg", 0.92); // or "image/png"
};
  // async resizeImage() {
  //   const scale = this.sliderValue / 100;
  //   try {
  //     const { width, height } = await this.calculateResizeSize(scale);

  //     const formData = new FormData();
  //     formData.append("format", "PNG");
  //     formData.append("rotate", "0");
  //     formData.append("perspective_horizontal", "0");
  //     formData.append("perspective_vertical", "0");
  //     formData.append("quality", "90");
  //     formData.append("mode", "resize");
  //     formData.append("width", width);
  //     formData.append("height", height);
  //     formData.append("image_url", this.url);

  //     const response = await picsArtInstance.post(`/edit`, formData);
  //     const { status, data } = response.data;

  //     if (status === "success") {
  //       this.updateCurrentURL(data.url);
  //     } else {
  //       console.error("Error: Unexpected response status", status);
  //     }
  //   } catch (error) {
  //     console.error(
  //       "Error occurred while updating image resize:",
  //       error.message,
  //     );
  //     console.error("Full error details:", error);
  //     throw new Error("Failed to update image resize. Please try again.");
  //   }
  // }

  //   async handleAdjustment(adjustments) {
  //     const {
  //       brightness,
  //       contrast,
  //       highlights,
  //       shadows,
  //       saturation,
  //       warmth: temperature,
  //       sharpen,
  //     } = adjustments;

  //     try {
  //       const formData = new FormData();
  //       formData.append("format", "PNG");
  //       formData.append("brightness", brightness);
  //       formData.append("contrast", contrast);
  //       formData.append("clarity", "5");
  //       formData.append("saturation", saturation);
  //       formData.append("hue", "0");
  //       formData.append("shadows", shadows);
  //       formData.append("highlights", highlights);
  //       formData.append("temperature", temperature);
  //       formData.append("sharpen", sharpen);
  //       formData.append("noise", "0");
  //       formData.append("vignette", "0");
  //       formData.append("image_url", this.url);

  //       // const response = await picsArtInstance.post(`/adjust`, formData);
  //       // const { status, data } = response.data;

  //       // if (status === "success") {
  //       //   this.updateCurrentURL(data.url);
  //       // } else {
  //       //   console.error(
  //       //     `Adjustment failed: Received unexpected status "${status}".`,
  //       //   );
  //       //   throw new Error(
  //       //     `Image adjustment failed due to server-side error. Status: ${status}`,
  //       //   );
  //       // }
  //     } catch (error) {
  //       const message =
  //         error.response?.data?.message || error.message || "Unknown error";
  //       console.error("Image adjustment failed:", message);
  //       throw new Error(`Image adjustment failed: ${message}`);
  //     }
  //   }
}

export default Functions;
